import React, { useEffect } from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import "../../assets/css/product_page.css";
import {
	arrival2,
	arrival3,
	arrival7,
	arrival8,
	product_img,
	review_img,
	seller_img,
	slide1,
	slide2,
	slide3,
	slide4,
} from "../../constants";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import $ from "jquery";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { useState } from "react";
import { Link } from "react-router-dom";

const Product_page = () => {
	const [Count, SetCount] = useState(0);
	if (Count < 0) {
		SetCount(0);
	}
	const settings_nav = {
		slidesToShow: 3,
		slidesToScroll: 1,
		asNavFor: ".slider-for",
		dots: true,
		centerMode: true,
		focusOnSelect: true,
	};
	const settings_for = {
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		asNavFor: ".slider-nav",
	};
	return (
		<>
			{/* Header starts here */}
			<Header />
			{/* Header ends here */}
			{/* product detail starts here */}
			<section className="product-detail">
				<div className="container">
					<div className="row">
						<div className="col-lg-6">
							<div className="product-slider-wrapper">
								<div className="single-slider">
									<img src={slide1} className="img-fluid" alt="" />
									<img src={slide2} className="img-fluid" alt="" />
									<img src={slide3} className="img-fluid" alt="" />
									<img src={slide4} className="img-fluid" alt="" />
								</div>
								<div className="main-slider-wrapper">
									<Zoom>
										<img src={product_img} className="img-fluid" alt="" />
									</Zoom>

									<div className="zoom-wrapper">
										<h6>
											<i className="fa fa-search-plus"></i> Mouse over to zoom
											in
										</h6>
									</div>
								</div>
							</div>
						</div>
						<div className="col-lg-4">
							<div className="product-detail-content-wrapper">
								<div className="product-breadcrumbs-wrapper">
									<ul>
										<li>
											<a href="/">Home</a>
										</li>
										<li>
											<a href="/shop">Shop</a>
										</li>
										<li>
											<a className="active" href="#">
												British Beef Mine (Typically 10% Fat)
											</a>
										</li>
									</ul>
								</div>
								<div className="detail-wrapper">
									<h3>Product name</h3>
									<h4>British Beef Mine (Typically 10% Fat)</h4>
									<div className="reviews-wrapper">
										<ul>
											<li>
												<i className="fa fa-star"></i>
											</li>
											<li>
												<i className="fa fa-star"></i>
											</li>
											<li>
												<i className="fa fa-star"></i>
											</li>
											<li>
												<i className="fa fa-star"></i>
											</li>
											<li>
												<i className="fa fa-star"></i>
											</li>
											<li>
												<span className="total-reviews">5 Reviews </span>
											</li>
										</ul>
									</div>
									<div className="best-seller-wrapper">
										<h4>
											<span>
												<svg
													xmlns="http://www.w3.org/2000/svg"
													width="15.334"
													height="19.203"
													viewBox="0 0 15.334 19.203"
												>
													<g
														id="badge-svgrepo-com_1_"
														data-name="badge-svgrepo-com (1)"
														transform="translate(-49.24 0)"
													>
														<g
															id="Group_8003"
															data-name="Group 8003"
															transform="translate(49.24 0)"
														>
															<path
																id="Path_16690"
																data-name="Path 16690"
																d="M64.378,8.692l-.236-.322a1.014,1.014,0,0,1-.008-1.19l.232-.326a1.023,1.023,0,0,0-.35-1.489l-.354-.189a1.018,1.018,0,0,1-.523-1.069l.067-.4a1.017,1.017,0,0,0-.963-1.187l-.4-.016a1.021,1.021,0,0,1-.935-.735l-.11-.385A1.018,1.018,0,0,0,59.416.736l-.369.157A1.022,1.022,0,0,1,57.883.638l-.267-.3a1.019,1.019,0,0,0-1.528.012l-.263.3a1.025,1.025,0,0,1-1.159.275L54.3.775a1.018,1.018,0,0,0-1.371.672l-.106.385a1.024,1.024,0,0,1-.923.75l-.4.024a1.018,1.018,0,0,0-.943,1.2l.071.393a1.022,1.022,0,0,1-.507,1.076l-.35.2a1.019,1.019,0,0,0-.33,1.493l.236.322a1.014,1.014,0,0,1,.008,1.19l-.232.326a1.023,1.023,0,0,0,.35,1.489l.354.189a1.018,1.018,0,0,1,.523,1.069l-.067.4a1.017,1.017,0,0,0,.963,1.187l.4.016a1.021,1.021,0,0,1,.935.735l.11.385a1.018,1.018,0,0,0,1.383.652l.369-.157a1.022,1.022,0,0,1,1.163.255l.267.3a1.019,1.019,0,0,0,1.528-.012l.263-.3a1.025,1.025,0,0,1,1.159-.275l.369.153a1.018,1.018,0,0,0,1.371-.672l.106-.385a1.024,1.024,0,0,1,.923-.75l.4-.024a1.018,1.018,0,0,0,.943-1.2l-.071-.393a1.022,1.022,0,0,1,.507-1.076l.35-.2A1.018,1.018,0,0,0,64.378,8.692ZM56.9,12.935a5.107,5.107,0,1,1,5.107-5.107A5.112,5.112,0,0,1,56.9,12.935Z"
																transform="translate(-49.24 0)"
															/>
															<path
																id="Path_16691"
																data-name="Path 16691"
																d="M293.383,361.126l-.177.012-.086.314a2.148,2.148,0,0,1-2.888,1.418l-.3-.126-.094.11,1.458,2.652a.594.594,0,0,0,.409.295l1.756.326a.591.591,0,0,0,.656-.361l.664-1.658a.58.58,0,0,0-.031-.5Z"
																transform="translate(-280.386 -346.938)"
															/>
															<path
																id="Path_16692"
																data-name="Path 16692"
																d="M76.558,364.819a2.107,2.107,0,0,1-.849.177,2.156,2.156,0,0,1-2.063-1.548l-.09-.31-.314-.012-1.32,2.4a.58.58,0,0,0-.031.5l.664,1.658a.591.591,0,0,0,.656.361l1.756-.326a.6.6,0,0,0,.409-.295l1.5-2.723-.012-.012Z"
																transform="translate(-70.959 -348.86)"
															/>
															<path
																id="Path_16693"
																data-name="Path 16693"
																d="M162.831,103.637a.644.644,0,0,0-.086-.809c-.475-.436-1.768-.145-1.768-.145h0c-.09.016-.185.035-.287.059,0,0-.448.208,0-1.147s-.3-1.568-.613-1.568-.208.672-.208.672a7.28,7.28,0,0,1-1.312,2.342,1.45,1.45,0,0,0-.31.523.575.575,0,0,0-.373-.138h-.86a.574.574,0,0,0-.574.574v2.294a.574.574,0,0,0,.574.574h.86a.555.555,0,0,0,.318-.1.6.6,0,0,0,.134-.452V104.89c0,.055.008,1.768.994,1.874.354.024.79.043,1.226.035a4.293,4.293,0,0,0,1.155-.035c1.139-.244.856-1.037.856-1.037a.781.781,0,0,0,.267-1.041A.7.7,0,0,0,162.831,103.637Z"
																transform="translate(-152.227 -96.096)"
															/>
														</g>
													</g>
												</svg>
											</span>
											Best Seller | John Doe
										</h4>
									</div>
									<div className="price-wrapper">
										<h3>$96.90</h3>
									</div>
									{/* variations starts  here */}
									<div className="sizes-wrapper">
										<div className="sizes-heading-wrapper">
											<h4>Weight</h4>
										</div>
										<div className="size-content-wrapper">
											<div className="radio_container">
												<input type="radio" name="radio" id="ones" />
												<label for="ones">12kg</label>
												<input type="radio" name="radio" id="twos" />
												<label for="twos">22kg</label>
												<input type="radio" name="radio" id="threes" />
												<label for="threes">32kg</label>
											</div>
										</div>
									</div>
									{/* variations ends  here */}
									<div className="quantity-card-wrapper">
										<div className="quantity-wrapper">
											<h4>Quantity:</h4>
											<div className="quantity-input-wrapper">
												<button
													onClick={() => SetCount(Count - 1)}
													className="back"
												>
													<i className="fa fa-angle-left"></i>
												</button>
												<input type="number" value={Count} />
												<button
													onClick={() => SetCount(Count + 1)}
													className="back"
												>
													<i className="fa fa-angle-right"></i>
												</button>
											</div>
										</div>
										<div className="btn-wrapper">
											<a href="/Product-cart" className="btn">
												Add To Cart
											</a>
										</div>
									</div>
									<div className="wishlist-wrapper">
										<Link to="/MyWishlist">
											<h5>
												<i className="fa fa-heart"></i>{" "}
												<span>Add To Wishlist</span>
											</h5>
										</Link>
									</div>
									<div className="other-deatils-wrapper">
										<ul>
											<li>
												<span className="property">SKU:</span>
												<span className="value">506-709A- KH</span>
											</li>
											<li>
												<span className="property">Category:</span>
												<span className="value">Fresh Meat</span>
											</li>
											<li>
												<span className="property">Tags:</span>
												<span className="value">
													beef, meat, frozen, fresh, organic, foods
												</span>
											</li>
											<li>
												<span className="property">Seller Name :</span>
												<span className="value"> Apricot Seller</span>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
						<div className="col-lg-2">
							<a href="/seller-store">
								<div className="seller-card-wrapper">
									<div className="img-wrapper">
										<figure>
											<img src={seller_img} alt="" />
										</figure>
									</div>
									<div className="seller-content-wrapper">
										<h4>John Doe</h4>
										<h6>
											<span>
												<svg
													xmlns="http://www.w3.org/2000/svg"
													width="15.334"
													height="19.203"
													viewBox="0 0 15.334 19.203"
												>
													<g
														id="badge-svgrepo-com_1_"
														data-name="badge-svgrepo-com (1)"
														transform="translate(-49.24 0)"
													>
														<g
															id="Group_8003"
															data-name="Group 8003"
															transform="translate(49.24 0)"
														>
															<path
																id="Path_16690"
																data-name="Path 16690"
																d="M64.378,8.692l-.236-.322a1.014,1.014,0,0,1-.008-1.19l.232-.326a1.023,1.023,0,0,0-.35-1.489l-.354-.189a1.018,1.018,0,0,1-.523-1.069l.067-.4a1.017,1.017,0,0,0-.963-1.187l-.4-.016a1.021,1.021,0,0,1-.935-.735l-.11-.385A1.018,1.018,0,0,0,59.416.736l-.369.157A1.022,1.022,0,0,1,57.883.638l-.267-.3a1.019,1.019,0,0,0-1.528.012l-.263.3a1.025,1.025,0,0,1-1.159.275L54.3.775a1.018,1.018,0,0,0-1.371.672l-.106.385a1.024,1.024,0,0,1-.923.75l-.4.024a1.018,1.018,0,0,0-.943,1.2l.071.393a1.022,1.022,0,0,1-.507,1.076l-.35.2a1.019,1.019,0,0,0-.33,1.493l.236.322a1.014,1.014,0,0,1,.008,1.19l-.232.326a1.023,1.023,0,0,0,.35,1.489l.354.189a1.018,1.018,0,0,1,.523,1.069l-.067.4a1.017,1.017,0,0,0,.963,1.187l.4.016a1.021,1.021,0,0,1,.935.735l.11.385a1.018,1.018,0,0,0,1.383.652l.369-.157a1.022,1.022,0,0,1,1.163.255l.267.3a1.019,1.019,0,0,0,1.528-.012l.263-.3a1.025,1.025,0,0,1,1.159-.275l.369.153a1.018,1.018,0,0,0,1.371-.672l.106-.385a1.024,1.024,0,0,1,.923-.75l.4-.024a1.018,1.018,0,0,0,.943-1.2l-.071-.393a1.022,1.022,0,0,1,.507-1.076l.35-.2A1.018,1.018,0,0,0,64.378,8.692ZM56.9,12.935a5.107,5.107,0,1,1,5.107-5.107A5.112,5.112,0,0,1,56.9,12.935Z"
																transform="translate(-49.24 0)"
																fill="#ed9521"
															/>
															<path
																id="Path_16691"
																data-name="Path 16691"
																d="M293.383,361.126l-.177.012-.086.314a2.148,2.148,0,0,1-2.888,1.418l-.3-.126-.094.11,1.458,2.652a.594.594,0,0,0,.409.295l1.756.326a.591.591,0,0,0,.656-.361l.664-1.658a.58.58,0,0,0-.031-.5Z"
																transform="translate(-280.386 -346.938)"
																fill="#ed9521"
															/>
															<path
																id="Path_16692"
																data-name="Path 16692"
																d="M76.558,364.819a2.107,2.107,0,0,1-.849.177,2.156,2.156,0,0,1-2.063-1.548l-.09-.31-.314-.012-1.32,2.4a.58.58,0,0,0-.031.5l.664,1.658a.591.591,0,0,0,.656.361l1.756-.326a.6.6,0,0,0,.409-.295l1.5-2.723-.012-.012Z"
																transform="translate(-70.959 -348.86)"
																fill="#ed9521"
															/>
															<path
																id="Path_16693"
																data-name="Path 16693"
																d="M162.831,103.637a.644.644,0,0,0-.086-.809c-.475-.436-1.768-.145-1.768-.145h0c-.09.016-.185.035-.287.059,0,0-.448.208,0-1.147s-.3-1.568-.613-1.568-.208.672-.208.672a7.28,7.28,0,0,1-1.312,2.342,1.45,1.45,0,0,0-.31.523.575.575,0,0,0-.373-.138h-.86a.574.574,0,0,0-.574.574v2.294a.574.574,0,0,0,.574.574h.86a.555.555,0,0,0,.318-.1.6.6,0,0,0,.134-.452V104.89c0,.055.008,1.768.994,1.874.354.024.79.043,1.226.035a4.293,4.293,0,0,0,1.155-.035c1.139-.244.856-1.037.856-1.037a.781.781,0,0,0,.267-1.041A.7.7,0,0,0,162.831,103.637Z"
																transform="translate(-152.227 -96.096)"
																fill="#ed9521"
															/>
														</g>
													</g>
												</svg>
											</span>
											<span>Best Seller</span>
										</h6>
									</div>
								</div>
							</a>
							<div className="become-seller">
								<h6>
									Become a Seller? <a href="#">Register now</a>{" "}
								</h6>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* product detail ends here */}
			{/* products tabs starts here */}
			<section className="products-tab-wrapper">
				<div className="container">
					<div className="row">
						<div className="col-lg-3">
							<div className="details-tab-wrapper">
								<ul className="nav nav-tabs" id="myTab" role="tablist">
									<li className="nav-item" role="presentation">
										<button
											className="nav-link active"
											id="Description-tab"
											data-bs-toggle="tab"
											data-bs-target="#Description"
											type="button"
											role="tab"
											aria-controls="Description"
											aria-selected="true"
										>
											Description
										</button>
									</li>
									<li className="nav-item" role="presentation">
										<button
											className="nav-link"
											id="Reviews-tab"
											data-bs-toggle="tab"
											data-bs-target="#Reviews"
											type="button"
											role="tab"
											aria-controls="Reviews"
											aria-selected="false"
										>
											Reviews <span>(5)</span>
										</button>
									</li>
								</ul>
							</div>
						</div>
						<div className="col-lg-9">
							<div className="tab-content" id="myTabContent">
								<div
									className="tab-pane fade show active"
									id="Description"
									role="tabpanel"
									aria-labelledby="Description-tab"
								>
									<div className="description-wrapper">
										<p>
											NOTE: It's a place holder with dummy text and full of
											flavor, this beef is the base of big, juicy burgers,
											savory meat loaf and rich Bolognese sauce. You can enjoy
											this delicious local ground beef for your meatloaf,
											burgers, meatballs, shepherd's pie, spicy taco meat and so
											much more.
										</p>
										<p>
											As one of Farmart's premium beef suppliers,{" "}
											<strong>Local Angus</strong>
											works with a coalition of small family farms throughout
											the Mid-Atlantic region* who feed their cattle a diet of
											primarily grass, supplemented by grain throughout the
											finishing months. Every farm in this program is
											independently audited for animal welfare practices to
											ensure the best standards of care.
										</p>
										<h4>Preparation and Usage</h4>
										<p>For perfectly cooked beef, our head chef recommends:</p>
										<h5>Storage</h5>
										<p>
											Keep refrigerated 0-5oC. Consume within the use by date.
											Once pack is opened use on the same day. Suitable for
											freezing on day of purchase. Use within one month. Defrost
											fully before use. Do not re-freeze once defrosted.
										</p>
										<h5>Pan Fry</h5>
										<p>
											Pour a little oil into a frying pan and cook for 4-6
											minutes until browned. If preferred, drain off excess fat.
											Add a good beef stock, seasonal vegetables and a
											sprinkling of sea salt and freshly ground black pepper.
											Bring to the boil and reduce heat to simmer for 20 minutes
											until the meat is thoroughly cooked and your kitchen
											smells delicious. Wash hands, knives and surfaces
											thoroughly before and after preparing raw meat.
										</p>
										<h5>Return To Address</h5>
										<p className="yellow">
											Daylesford near Kingham, Gloucestershire GL56 0YG
										</p>
										<h5>Country of Origin</h5>
										<p>UK</p>
										<h5>Package Type</h5>
										<p>Box & Sleeve</p>
										<p>
											Wash hands, knives and surfaces thoroughly before and
											after preparing raw meat.
										</p>
										<h5>Recycling Information</h5>
										<p>
											You'll never be given a plastic carrier bag in our farm
											shops, and for this packaging we've chosen a tray that is
											70% post-consumer recycled material. Like this
											FSC-certified cardboard, it is fully recyclable &
											rechangable.
										</p>
										<h5>Other Information</h5>
										<ul>
											<li>GB-ORG-05, EU Agriculture</li>
											<li>UK 4707 EC</li>
											<li>Packaged in a protective atmosphere</li>
										</ul>
										<p>
											We've been farming organically for over 35 years, meaning
											our animals enjoy their natural grass and forage-based
											diet, growing into strong and healthy animals, free from
											unnecessary chemicals, antibiotics and GM feed.
										</p>
										<p>
											We choose British breeds who thrive in their native
											landscape and encourage healthy biodiversity on our farm.
											We avoid waste of any kind, so manure and kitchen waste
											compost are returned to the soil as rich natural
											fertilisers. We have built our own abattoir to ensure the
											highest animal welfare and reduced food miles, which
											results in better tasting meat, and we spread our message
											far beyond the boundaries of our own fields.
										</p>
										<p>
											Each step of our journey is made with a conscience, and a
											love for food.
										</p>
									</div>
								</div>
								<div
									className="tab-pane fade"
									id="Reviews"
									role="tabpanel"
									aria-labelledby="Reviews-tab"
								>
									<div className="reviews-wrapper">
										<div className="heading-wrapper">
											<h5>Our Clients Reviews</h5>
											<p>
												Lorem ipsum dolor sit amet, consectetur adipiscing elit,
												sed do eiusmod tempor incididunt ut labore et
												dolore.Lorem ipsum dolor sit amet, consectetur
												adipiscing elit, sed do eiusmod tempor incididunt ut
												labore et dolore.Lorem ipsum dolor sit amet,Lorem ipsum
												dolor sit amet
											</p>
										</div>
										<div className="single-review-wrapper">
											<div className="single-img-wrapper">
												<figure>
													<img src={review_img} className="img-fluid" alt="" />
												</figure>
											</div>
											<div className="single-reviews-content-wrapper">
												<h5>John Doe</h5>
												<h6>08 Nov 2022</h6>
												<p>
													Lorem ipsum dolor sit amet, consectetur adipiscing
													elit, sed do eiusmod tempor incididunt ut labore et
													dolore magna aliqua. Ut enim ad minim veniam, quis
													nostrud exercitation ullamco laboris nisLorem ipsum
													dolor sit amet, consectetur adipiscing elit, sed do
													eiusmod tempor incididunt ut labore et
												</p>
												<button className="reply">Reply :</button>
											</div>
										</div>
										<div className="single-review-wrapper">
											<div className="single-img-wrapper">
												<figure>
													<img src={review_img} className="img-fluid" alt="" />
												</figure>
											</div>
											<div className="single-reviews-content-wrapper">
												<h5>John Doe</h5>
												<h6>08 Nov 2022</h6>
												<p>
													Lorem ipsum dolor sit amet, consectetur adipiscing
													elit, sed do eiusmod tempor incididunt ut labore et
													dolore magna aliqua. Ut enim ad minim veniam, quis
													nostrud exercitation ullamco laboris nisLorem ipsum
													dolor sit amet, consectetur adipiscing elit, sed do
													eiusmod tempor incididunt ut labore et
												</p>
												<button className="reply">Reply :</button>
											</div>
										</div>
									</div>
									<div className="add-review-wrapper">
										<div className="heading-wrapper">
											<h3>Add Review</h3>
										</div>
										<div className="review-form-wrapper">
											<form action="">
												<div className="form-group row">
													<div className="col-lg-4">
														<input
															className="form-control"
															placeholder="Name"
															type="text"
														/>
													</div>

													<div className="col-lg-4">
														<input
															className="form-control"
															placeholder="Email"
															type="text"
														/>
													</div>
													<div className="col-lg-4">
														<div className="rate-wrapper">
															<label htmlFor="">Your Rating</label>
															<div id="full-stars-example-two">
																<div className="rating-group">
																	<input
																		disabled
																		checked
																		className="rating__input rating__input--none"
																		name="rating3"
																		id="rating3-none"
																		value="0"
																		type="radio"
																	/>
																	<label
																		aria-label="1 star"
																		className="rating__label"
																		for="rating3-1"
																	>
																		<i className="rating__icon rating__icon--star fa fa-star"></i>
																	</label>
																	<input
																		className="rating__input"
																		name="rating3"
																		id="rating3-1"
																		value="1"
																		type="radio"
																	/>
																	<label
																		aria-label="2 stars"
																		className="rating__label"
																		for="rating3-2"
																	>
																		<i className="rating__icon rating__icon--star fa fa-star"></i>
																	</label>
																	<input
																		className="rating__input"
																		name="rating3"
																		id="rating3-2"
																		value="2"
																		type="radio"
																	/>
																	<label
																		aria-label="3 stars"
																		className="rating__label"
																		for="rating3-3"
																	>
																		<i className="rating__icon rating__icon--star fa fa-star"></i>
																	</label>
																	<input
																		className="rating__input"
																		name="rating3"
																		id="rating3-3"
																		value="3"
																		type="radio"
																	/>
																	<label
																		aria-label="4 stars"
																		className="rating__label"
																		for="rating3-4"
																	>
																		<i className="rating__icon rating__icon--star fa fa-star"></i>
																	</label>
																	<input
																		className="rating__input"
																		name="rating3"
																		id="rating3-4"
																		value="4"
																		type="radio"
																	/>
																	<label
																		aria-label="5 stars"
																		className="rating__label"
																		for="rating3-5"
																	>
																		<i className="rating__icon rating__icon--star fa fa-star"></i>
																	</label>
																	<input
																		className="rating__input"
																		name="rating3"
																		id="rating3-5"
																		value="5"
																		type="radio"
																	/>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div className="form-group">
													<textarea
														name=""
														placeholder="Your Review"
														className="form-control"
														id=""
														cols="30"
														rows="5"
													></textarea>
												</div>
												<div className="form-group row mt-4">
													<div className="col-lg-10">
														<div className="form-check">
															<input
																className="form-check-input"
																type="checkbox"
																value=""
																id="flexCheckDefault"
															/>
															<label
																className="form-check-label"
																for="flexCheckDefault"
															>
																By using this form you agree with the storage
																and handling of your data by this website.
															</label>
														</div>
													</div>
													<div className="col-lg-2">
														<button type="submit">Submit</button>
													</div>
												</div>
											</form>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* products tabs ends here */}
			{/* products starts here */}
			<section className="product-sec pro-sec">
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<div className="row">
								<div className="col-lg-3 px-0">
									<div className="product-card-wrapper">
										<div className="product-img-wrapper">
											<figure>
												<img src={arrival3} className="img-fluid" alt="" />
											</figure>
										</div>
										<div className="product-content-wrapper">
											<h5>Brand Name</h5>
											<span className="ice">Asia Green Bananas</span>
											<div className="rating-wrapper">
												<ul>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li className="total-rating">
														<span>(1)</span>
													</li>
												</ul>
											</div>
											<h6>5kg</h6>
											<h4>$19.25</h4>

											<div className="counter-total-wrapper">
												<input type="number" min={0} />
												<h6>
													Total: <span>$38.5</span>
												</h6>
											</div>
											<a href="#" className="btn">
												Add To Cart
											</a>
										</div>
									</div>
								</div>
								<div className="col-lg-3 px-0">
									<div className="product-card-wrapper">
										<div className="product-img-wrapper">
											<figure>
												<img src={arrival2} className="img-fluid" alt="" />
											</figure>
										</div>
										<div className="product-content-wrapper">
											<h5>Farmart</h5>
											<span className="ice">
												British Beef Mine (Typically 10% Fat)
											</span>
											<div className="rating-wrapper">
												<ul>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li className="total-rating">
														<span>(6)</span>
													</li>
												</ul>
											</div>
											<h6>454g</h6>
											<h4>$96.90</h4>

											<div className="counter-total-wrapper">
												<input type="number" min={0} />
												<h6>
													Total: <span>$96.90</span>
												</h6>
											</div>
											<a href="#" className="btn">
												Add To Cart
											</a>
										</div>
									</div>
								</div>
								<div className="col-lg-3 px-0">
									<div className="product-card-wrapper">
										<div className="product-img-wrapper">
											<figure>
												<img src={arrival7} className="img-fluid" alt="" />
											</figure>
											<div className="save-wrapper">
												<h6>Save 12%</h6>
											</div>
										</div>
										<div className="product-content-wrapper">
											<h5>MartFury</h5>
											<span className="ice">US Yellow Water Melon</span>
											<div className="rating-wrapper">
												<ul>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li className="total-rating">
														<span>(2)</span>
													</li>
												</ul>
											</div>
											<h6>2kg</h6>
											<h4>
												<span style={{ color: "#FA532C" }}>$59.50 </span>
												<strike style={{ color: "#666666", FontSize: "12px" }}>
													{" "}
													$69.70
												</strike>
											</h4>

											<div className="counter-total-wrapper">
												<input type="number" min={0} />
												<h6>
													Total: <span>$38.5</span>
												</h6>
											</div>
											<a href="#" className="btn">
												Add To Cart
											</a>
										</div>
									</div>
								</div>
								<div className="col-lg-3 px-0">
									<div className="product-card-wrapper">
										<div className="product-img-wrapper">
											<figure>
												<img src={arrival8} className="img-fluid" alt="" />
											</figure>
											<div className="save-wrapper">
												<h6>Save 34%</h6>
											</div>
										</div>
										<div className="product-content-wrapper">
											<h5>Farmart</h5>
											<span className="ice">Spicies Snacks 6 Ready Salted</span>
											<div className="rating-wrapper">
												<ul>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li className="total-rating">
														<span>(2)</span>
													</li>
												</ul>
											</div>
											<h6>100g</h6>
											<h4>
												<span style={{ color: "#FA532C" }}>$2.5 </span>
												<strike style={{ color: "#666666", FontSize: "12px" }}>
													$7.5
												</strike>
											</h4>

											<div className="counter-total-wrapper">
												<input type="number" min={0} />
												<h6>
													Total: <span>$38.5</span>
												</h6>
											</div>
											<a href="#" className="btn">
												Add To Cart
											</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* products ends here */}
			{/* Footer starts here */}
			<Footer />
			{/* Footer ends here */}
		</>
	);
};

export default Product_page;
